import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {InputDate} from '@/components/commons/input-date-legacy/InputDate'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {FormFieldBox} from '@/components/ui/form-atoms/FormAtoms'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {PatientPrivacyFormValidationSchema} from '@/features/patients/types'

export const PatientPrivacyFields = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<PatientPrivacyFormValidationSchema>()

    // form observer
    const fm01 = useWatch({control: form.control, name: 'fm01'})

    return (
        <Flexbox direction="column" gap={3}>
            <FormFieldBox fitContent isSelected={fm01} hasError={!!form.formState.errors.fm01}>
                <Checkbox
                    id="fm01"
                    label={t('patients:signed_fm01')}
                    {...form.register('fm01', {
                        onChange: event => {
                            if (!event.target.checked) {
                                form.setValue('privacy1', false, {shouldDirty: true})
                                form.setValue('privacy2', false, {shouldDirty: true})
                                form.setValue('privacy3', false, {shouldDirty: true})
                                form.setValue('privacy4', false, {shouldDirty: true})
                                form.setValue('consentDateFm01', null, {shouldDirty: true})
                            }
                        }
                    })}
                />
            </FormFieldBox>

            {fm01 && (
                <Flexbox direction="column" gap={3}>
                    <Label>{t('patients:consents')}</Label>
                    <Flexbox gap={6} style={{flexWrap: 'wrap'}}>
                        <Checkbox
                            id="privacy1"
                            label={t('patients:orientation_advice')}
                            {...form.register('privacy1')}
                        />
                        <Checkbox
                            id="privacy2"
                            label={t('patients:notifications_events')}
                            {...form.register('privacy2')}
                        />
                        <Checkbox
                            id="privacy3"
                            label={t('patients:sending_questionnaires')}
                            {...form.register('privacy3')}
                        />
                        <Checkbox id="privacy4" label={t('patients:sending_sms')} {...form.register('privacy4')} />
                    </Flexbox>

                    <Controller
                        name="consentDateFm01"
                        control={form.control}
                        render={({field}) => (
                            <InputDate
                                label={t('patients:consent_date')}
                                placeholder="GG/MM/AAAA"
                                errorMessage={form.formState.errors.consentDateFm01?.message}
                                maxDate={dayjs().toDate()}
                                numMonths={1}
                                selectedDates={field.value ? [field.value] : []}
                                onChange={field.onChange}
                            />
                        )}
                    />
                </Flexbox>
            )}
        </Flexbox>
    )
}
